"use strict";

exports.__esModule = true;
exports["default"] = Tag;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Tag(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M510.226 184.463l-17.538-75.597c-2.704-11.758-4.944-21.417-4.944-21.417s-3.167-9.427-7.009-20.847c0 0-2.917-8.895-14.657-20.634s-20.669-14.71-20.669-14.71c-11.454-3.806-20.812-6.973-20.812-6.973s-9.676-2.277-21.416-4.981L327.584 1.765C315.81-.956 299.16 3.811 290.656 12.331L7.377 295.567c-8.502 8.536-8.502 22.554 0 31.021l178.016 178.021c8.538 8.521 22.484 8.521 31.057 0l283.21-283.235c8.537-8.521 13.305-25.152 10.566-36.911zm-85.558-97.139c13.839 13.822 13.839 36.252 0 50.073-13.803 13.785-36.18 13.803-50.017-.036-13.804-13.803-13.804-36.215 0-50.02 13.837-13.82 36.214-13.82 50.017-.017z"
  }));
}